/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from 'react';
import { TabLabels, TabNames } from './props';



export interface CustomProps {
  tabName: TabNames;
  tabChangeHandler: (tabName: TabNames) => void;
  pendingCount?: number;
  requestedCount?: number;
  approvedCount?: number;
  completedCount?: number;
}

const Tabs: React.FunctionComponent<CustomProps> = (props) => {
  const [tabName, setTabName] = React.useState<TabNames>(
    props.tabName || TabNames.Requests
  );

  const setElementActive = (tabValue: TabNames) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };

  return (
    <ul
      className="d-flex list-unstyled tab-underline font-sm font-weight-semibold text-nowrap overflow-auto m-0"
      id="activity-tab"
      role="tablist"
    >
      {Object.entries(TabNames).map(([key, value]) => {
        const label = TabLabels[key as keyof typeof TabLabels];
        return (
          <li className="nav-item pr-4 pl-4" role="presentation">
            <a
              className={`cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ${
                tabName === value ? 'active' : ''
              }`}
              onClick={(e) => setElementActive(value)}
            >
              <span className="py-1 d-inline-flex">{label}</span>
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default Tabs;
